// @flow
import React from 'react'
import { Helmet } from 'react-helmet'
import classNames from 'classnames'
import Layout from '../layout'
import styles from './sponsors.module.css'

const sponsors = {
  golden: [
    {
      id: 'clarivate-analytics',
      name: 'Clarivate analytics',
      url: 'https://clarivate.com',
    },
    {
      id: 'ebsco',
      name: 'EBSCO',
      url: 'https://www.ebsco.com',
    },
    {
      id: 'elsevier',
      name: 'Elsevier',
      url: 'https://www.elsevier.com',
    },
    {
      id: 'crossref',
      name: 'Crossref',
      url: 'https://www.crossref.org',
    },
  ],
  bronze: [
    {
      id: 'copernicus',
      name: 'Copernicus',
      url: 'https://publications.copernicus.org/',
    },
    {
      id: 'rsc',
      name: 'Royal Society of Chemistry',
      url: 'https://www.rsc.org',
    },
  ],
}

const supporters = [
  {
    id: 'ease',
    name: 'EASE',
    url: 'https://ease.org.uk',
  },
  {
    id: 'mzo',
    name: 'Croatian Ministry of Science and Education',
    url: 'https://mzo.hr/en',
  },
  {
    id: 'open-aire',
    name: 'OpenAIRE',
    url: 'https://www.openaire.eu',
  },
  {
    id: 'sparc-europe',
    name: 'SPARC Europe',
    url: 'https://sparceurope.org',
  },
]

function SponsorsPage() {
  return (
    <Layout>
      <Helmet>
        <title>Sponsors</title>
      </Helmet>
      <h1>Sponsors</h1>
      <ul className={classNames(styles.list, styles.isGolden)}>
        {sponsors.golden.map((sponsor) => (
          <li key={sponsor.id} className={styles.item}>
            <a className={styles.link} href={sponsor.url}>
              <img
                className={styles.image}
                alt={sponsor.name}
                src={`https://res.cloudinary.com/pubmet/image/upload/e_trim,c_fit,h_512/v1/sponsors/${sponsor.id}.png`}
              />
            </a>
          </li>
        ))}
      </ul>
      <ul className={classNames(styles.list, styles.isBronze)}>
        {sponsors.bronze.map((sponsor) => (
          <li key={sponsor.id} className={styles.item}>
            <a className={styles.link} href={sponsor.url}>
              <img
                className={styles.image}
                alt={sponsor.name}
                src={`https://res.cloudinary.com/pubmet/image/upload/e_trim,c_fit,h_512/v1/sponsors/${sponsor.id}.png`}
              />
            </a>
          </li>
        ))}
      </ul>
      <p>
        Under the auspices of EASE, the Croatian Ministry of Science and
        Education, SPARC Europe and OpenAIRE:
      </p>
      <ul className={styles.list}>
        {supporters.map((supporter) => (
          <li key={supporter.id} className={styles.item}>
            <a className={styles.link} href={supporter.url}>
              <img
                className={styles.image}
                alt={supporter.name}
                src={`https://res.cloudinary.com/pubmet/image/upload/e_trim,c_fit,h_512/v1/supporters/${supporter.id}.png`}
              />
            </a>
          </li>
        ))}
      </ul>
    </Layout>
  )
}

export default SponsorsPage
